import { Amplify } from 'aws-amplify';

// Must match the callbackUrls / logoutUrls registered on the User Pool Client
// in ops-utility-hub-cognito (see cdk/bin/app.ts) — Cognito rejects the OAuth
// redirect with "redirect_mismatch" if these don't match exactly.
export const AUTH_CALLBACK_PATH = '/auth/callback';
export const LOGOUT_PATH = '/logged-out';

export const configureAmplify = (): void => {
  const {
    VITE_APP_URL: appUrl,
    VITE_COGNITO_DOMAIN: domain,
    VITE_COGNITO_USER_POOL_CLIENT_ID: userPoolClientId,
    VITE_COGNITO_USER_POOL_ID: userPoolId,
  } = import.meta.env;

  Amplify.configure({
    Auth: {
      Cognito: {
        loginWith: {
          oauth: {
            domain,
            redirectSignIn: [`${appUrl}${AUTH_CALLBACK_PATH}`],
            redirectSignOut: [`${appUrl}${LOGOUT_PATH}`],
            responseType: 'code',
            scopes: ['openid', 'email', 'profile'],
          },
        },
        userPoolClientId,
        userPoolId,
      },
    },
  });
};

// Name of the custom OIDC identity provider Cognito federates to (KochID),
// set up in ops-utility-hub-cognito's OpsUtilityHubCognitoStack. The User
// Pool Client only supports this provider — there is no native Cognito
// username/password sign-in — so every sign-in must go through this redirect.
export const getIdentityProviderName = (): string => {
  const { VITE_COGNITO_IDENTITY_PROVIDER_NAME: identityProviderName } = import.meta.env;
  if (!identityProviderName) {
    throw new Error('VITE_COGNITO_IDENTITY_PROVIDER_NAME is not defined in environment variables');
  }
  return identityProviderName;
};
